/**
 *
 * @param cityName - name of the city in English
 * @param prefectureName - name of the prefecture in English
 * @returns an array containing the formatted city and prefecture names (`[city, prefecture]`)
 */
function convertCityPrefecture(cityName: string, prefectureName: string): string[] {
  const city = cityName
    .toLowerCase()
    .replaceAll(' ', '+')
    .replace(/[^a-z0-9+]/g, '');

  const prefecture = prefectureName
    .toLowerCase()
    .replaceAll(' ', '+')
    .replace(/[^a-z0-9+]/g, '');

  return [city, prefecture];
}

export default convertCityPrefecture;
